import { Skeleton } from '@mui/material';
import { MasterAdminCardSkeleton } from './components';
import { BrokerGrid, ScreenContainer } from './styled';

const SKELETON_COUNT = 10;

export const MasterAdminSkeleton = () => (
  <ScreenContainer>
    <Skeleton variant="text" width={220} height={40} animation="wave" />
    <Skeleton variant="rounded" width="100%" height={48} animation="wave" />
    <BrokerGrid>
      {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
        <MasterAdminCardSkeleton key={i} />
      ))}
    </BrokerGrid>
  </ScreenContainer>
);
